import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Navbar() {
  const { isAuthenticated, user, points, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const lowPoints = points !== null && points <= 2;
  const noPoints = points !== null && points <= 0;

  const pointsBadgeClass = noPoints
    ? 'text-sm font-semibold px-2.5 py-1 rounded-full text-red-700 bg-red-50 border border-red-200'
    : lowPoints
    ? 'text-sm font-semibold px-2.5 py-1 rounded-full text-orange-700 bg-orange-50 border border-orange-200'
    : 'text-sm font-semibold px-2.5 py-1 rounded-full text-amber-700 bg-amber-50 border border-amber-200';

  const mobilePointsBadgeClass = noPoints
    ? 'text-xs font-semibold px-2 py-1 rounded-full text-red-700 bg-red-50 border border-red-200'
    : lowPoints
    ? 'text-xs font-semibold px-2 py-1 rounded-full text-orange-700 bg-orange-50 border border-orange-200'
    : 'text-xs font-semibold px-2 py-1 rounded-full text-amber-700 bg-amber-50 border border-amber-200';

  return (
    <nav className="bg-white shadow-sm flex items-center justify-between px-4 sm:px-6 py-3 sticky top-0 z-50">
      <Link to="/" className="flex items-center gap-2">
        <img src="/logo.png" alt="Logo" className="h-8 sm:h-10" />
        <span className="font-bold text-red-800 text-lg sm:text-xl">BoVi Price</span>
      </Link>
      
      <div className="hidden md:flex items-center gap-4">
        <Link to="/" className="text-gray-600 hover:text-red-800 font-medium text-sm">Home</Link>
        <Link to="/search" className="text-gray-600 hover:text-red-800 font-medium text-sm">Search</Link>
        <Link to="/stores" className="text-gray-600 hover:text-red-800 font-medium text-sm">Stores</Link>
        {isAuthenticated ? (
          <>
            <Link to="/upload" className="font-semibold px-3 py-2 rounded-lg text-sm transition bg-red-800 hover:bg-red-900 text-white">
              Upload Receipt
            </Link>
            {points !== null && (
              <Link to="/profile" className={pointsBadgeClass} title={lowPoints ? 'Share a receipt to keep searching' : `${points} pts`}>
                {points} pts
              </Link>
            )}
            {lowPoints && (
              <Link to="/upload" className="text-xs text-orange-600 font-medium hover:text-orange-700 transition">
                Upload for more searches
              </Link>
            )}
            <Link to="/profile" className="text-gray-600 hover:text-red-800 font-medium text-sm">
              {user?.name ? user.name.split(' ')[0] : 'Profile'} 
            </Link>
            <button 
              onClick={handleLogout} 
              className="text-gray-500 hover:text-red-600 font-medium text-sm transition"
            >
              Logout
            </button>
          </>
        ) : (
          <>
            <Link to="/login" className="text-gray-600 hover:text-red-800 font-medium text-sm">Login</Link>
            <Link to="/register" className="bg-red-800 hover:bg-red-900 text-white font-semibold px-3 py-2 rounded-lg text-sm transition">
              Register
            </Link>
          </>
        )}
      </div>

      <div className="flex md:hidden items-center gap-2">
        {isAuthenticated && points !== null && (
          <Link to="/profile" className={mobilePointsBadgeClass}>
            {points} pts
          </Link>
        )}
        {isAuthenticated && noPoints && (
          <Link to="/upload" className="text-xs text-red-800 font-semibold">
            Earn pts
          </Link>
        )}
        {!isAuthenticated && (
          <Link to="/register" className="text-sm text-red-800 font-medium">Sign Up Free</Link>
        )}
      </div>
    </nav>
  );
}
